import { useQuery } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { IFileRequestSurveyResponse, IOperationResultNoValue } from '../../surveys/models/Api';

export const GET_FILE_REQUEST_SURVEY_RESPONSE_BY_TOKEN_QUERY_KEY = 'getByTokenQueryFileRequestSurveyKey';

export const useClientGetFileRequestSurveyResponseByToken = ({
	accessToken,
	enabled = true,
	refetchOnWindowFocus = false,
	retry,
}: {
	accessToken: string;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	retry?: boolean | number | ((failureCount: number, error: IOperationResultNoValue) => boolean);
}) => {
	const { apiClient } = useApiClientContext();

	return useQuery({
		enabled,
		queryFn: () => {
			return apiClient.get<IFileRequestSurveyResponse>(`survey/filerequest/response/byToken?token=${accessToken}`);
		},
		queryKey: [GET_FILE_REQUEST_SURVEY_RESPONSE_BY_TOKEN_QUERY_KEY, accessToken],
		refetchOnWindowFocus,
		retry,
	});
};
